import React from "react";

import {MessageProps, Sender} from "./types/messages";

import {getSetting} from "./utils/settings";

import {AppointmentFormMessage} from "./Messages/AppointmentFormMessage";
import {CallbackFormMessage} from "./Messages/CallbackFormMessage";
import {ContactFormMessage} from "./Messages/ContactFormMessage";
import {ContactSuggestion} from "./Messages/ContactSuggestion";
import {ContentSuggestion} from "./Messages/ContentSuggestion";
import {LoadingMessage} from "./Messages/LoadingMessage";
import {TextMessage} from "./Messages/TextMessage";
import {ErrorMessage} from "./Messages/ErrorMessage";

function Avatar({sender}: {sender: Sender}): React.ReactElement|null {
    const display = getSetting( 'appearance.display_name' );

    if ( display ) {

        return null;
    }

    return (
        <div className={`wvcb-message__avatar wvcb-message__avatar--${sender}`}></div>
    )
}

function Name({sender}: {sender: Sender}): React.ReactElement|null {
    const display = getSetting( 'appearance.display_name' );

    if ( display ) {

        return null;
    }

    const name = sender === 'bot'
        ?  getSetting( 'appearance.bot_name' )
        : getSetting( 'appearance.user_name' );

    return (
        <div className={`wvcb-message__name wvcb-message__name--${sender}`}>{name}</div>
    )
}

export function Message(msg: MessageProps): React.ReactElement|null {
    const body = () => {
        switch (msg.type) {
            case "appointment-form":
                return <AppointmentFormMessage text={msg.text}/>;
            case "callback-form":
                return <CallbackFormMessage text={msg.text}/>;
            case "contact-form":
                return <ContactFormMessage text={msg.text}/>;
            case "contact-person":
            case "contact-suggestion":
                return <ContactSuggestion text={msg.text} id={msg.data as number}/>;
            case "content-suggestion":
                return <ContentSuggestion text={msg.text} id={msg.data as number}/>;
            case "error":
                return <ErrorMessage text={msg.text}/>;
            case "loading":
                return <LoadingMessage/>;
            default:
                return <TextMessage text={msg.text}/>;
        }
    };

    return (
        <li className={`wvcb-message wvcb-message--${msg.sender} wvcb-message--${msg.type}`}>
            <Avatar sender={msg.sender}/>
            <div className="wvcb-message__body">
                <Name sender={msg.sender}/>
                <div className="wvcb-message__body-inner">
                    {body()}
                </div>
            </div>
        </li>
    )
};

